// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_NllIbxEW","iconContainer":"_3f7gB-_A","title":"_OASoHtVk","description":"_ggyexCOK"};